const Twitch = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.4583 11.6875L16.375 14.7709H13.2917L10.5937 17.4688V14.7709H7.125V3.20837H19.4583V11.6875Z'
        fill='white'
      />
      <path
        d='M6.35417 1.66663L2.5 5.52079V19.3958H7.125V23.25L10.9792 19.3958H14.0625L21 12.4583V1.66663H6.35417ZM19.4583 11.6875L16.375 14.7708H13.2917L10.5937 17.4687V14.7708H7.125V3.20829H19.4583V11.6875Z'
        fill='#9146FF'
      />
      <path d='M17.1458 5.90625H15.6041V10.5312H17.1458V5.90625Z' fill='#9146FF' />
      <path d='M12.9062 5.90625H11.3645V10.5312H12.9062V5.90625Z' fill='#9146FF' />
    </svg>
  );
};

export default Twitch;
